import { render, staticRenderFns } from "./logins.vue?vue&type=template&id=a71d8bee"
import script from "./logins.vue?vue&type=script&lang=js"
export * from "./logins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports